// extracted by mini-css-extract-plugin
module.exports = {"textinput-wrapper":"TextArea_textinput-wrapper__Vhwsc","invalid":"TextArea_invalid__oPDYn","long":"TextArea_long__X5jqf"};